/*=========================================================================================
  File Name: state.js
  Namespace: quizzes
  Description: Vuex Store - Quiz state
==========================================================================================*/

import {
  quizFactory
} from './factories'

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  quiz: quizFactory(),
  // use answerFactory and questionFactory to fill this 2 objects of objects.
  questions: {},
  answers: {},
  quizList: null,
  count: 0,
  next: null,
  previous: null,
  results: []
}

export default state